import UserTableContainer from './UserTableContainer';
import UserListData from "./services/UserListData";
import stores from './stores';

const UserTable = {
  path: [`/users`],
  exact: true,
  services: [new UserListData()],
  stores: stores,
  component: UserTableContainer,
};

export default UserTable;